import styled, { keyframes } from 'styled-components';
import { beam } from '@styles/colors/themes';

import { ControlledMenu, MenuButton, MenuItem } from '@szhsin/react-menu';
import {
  menuSelector,
  menuDividerSelector,
} from '@szhsin/react-menu/style-utils';

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
export const ContainerSidebar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 8px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;
interface IIcon {
  width: number;
}
export const Block = styled.div<IIcon>`
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: absolute;
  top: 0px;
  right: 0;
  width: 261px;
  z-index: 10;
  cursor: auto;
`;
export const CircleDiv = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  color: ${beam.color.pureWhite};
  background: ${beam.color.primaryBlue};

  border-radius: 50%;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  font-size: 10px;
  font-weight: 700;
  right: -5px;
  bottom: -5px;
  width: 14px;
  height: 14px;
`;

export const Icon = styled.div<IIcon>`
  min-width: ${({ width }) => width}px;
  width: ${({ width }) => width}px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const MenuIcon = styled.div`
  padding-top: 5px;
  cursor: pointer;
`;

//

const menuShow = keyframes`
  from {
    opacity: 0;
  }
`;
const menuHide = keyframes`
  to {
    opacity: 0;
  }
`;

export const Menu = styled(ControlledMenu)`
  ${menuSelector.name} {
    font-size: 0.925rem;
    user-select: none;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
    border-radius: 8px;
    padding: 12px 16px 24px 16px;
    width: 261px;
    transition: unset;
  }

  ${menuSelector.stateOpen} {
    animation: ${menuShow} 0.2s linear;
  }

  // NOTE: animation-fill-mode: forwards is required to
  // prevent flickering with React 18 createRoot()
  ${menuSelector.stateClosing} {
    animation: ${menuHide} 0.2s ease-out forwards;
  }

  ${menuDividerSelector.name} {
    margin: 0.5rem 0.625rem;
  }
`;

export const IconButton = styled(MenuButton)`
  border: 0;
  background-color: transparent;
`;

interface IIconWrapper {
  hoverColor?: string;
  width?: string;
  height?: string;
  paddingTop?: string;
}

export const IconWrapper = styled.div<IIconWrapper>`
  width: ${({ width }) => width || '32px'};
  height: ${({ height }) => height || '32px'};
  border: 0;
  border-radius: 8px;
  background-color: transparent;
  padding-top: ${({ paddingTop }) => paddingTop || '5px'};

  transition: 0.2s;

  :hover {
    background-color: ${({ hoverColor }) => hoverColor || '#f6f8ff'};
  }
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 16px;
  font-weight: 600;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  margin-bottom: 16px;
`;

export const Close = styled(MenuItem)`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 5px;
  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const Item = styled(MenuItem)`
  display: flex;
  flex-flow: column;
  min-height: 42px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  color: ${beam.font.primary};
  gap: 4px;

  transition: 0.2s;
  :hover {
    background-color: #f6f8ff;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;

  & span {
    display: inline-flex;
  }
`;

interface IItemText {
  disabled?: boolean;
  description?: string;
}

export const ItemText = styled.div<IItemText>`
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  color: ${({ disabled }) => (disabled ? '#c1c4d6' : '#474d66')};
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Description = styled.div<IItemText>`
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: ${({ disabled }) => (disabled ? '#c1c4d6' : '#696f8c')};
  margin-left: 25px;
  display: ${({ description }) => !description && 'none'};
`;

export const WarningBox = styled.div`
  font-family: 'Poppins' sans-serif;
  background: #fdf7f4;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 16px;
`;

export const Warning = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  margin-bottom: 8px;

  span {
    display: inline-flex;
  }
`;

export const WarningHeading = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #1b203a;
  margin: unset;
`;

export const WarningMessage = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #696f8c;
`;

export const Separators = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 1px solid #e6e8f0;
  margin: 4px 0;
`;

export const Wrapper = styled.div``;
